// extracted by mini-css-extract-plugin
export default {"filterItem":"MobileFilterItem_filterItem__vsXBh","filterItemActive":"MobileFilterItem_filterItemActive__gbjdt","filterItemLabel":"MobileFilterItem_filterItemLabel__SQH9c"};